import { CloseCircleOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch, RootState } from '../../../../service/drawings/src/ui/store';
import { setManyModel, setterInspector } from './store/slices/inspector-slice';

interface ButtonCloseAllInspectorProps {
    offsetRight: number;
}

export const ButtonCloseAllInspector: React.FC<ButtonCloseAllInspectorProps> = ({ offsetRight }) => {
    const dispatch = useDispatch<AppDispatch>();

    const isCloseAll = useSelector<RootState, boolean>((state) => state.inspector.isCloseAll);

    useEffect(() => {
        if (isCloseAll) {
            dispatch(setManyModel([]));
            dispatch(setterInspector({ isCloseAll: false, nameNewEntity: undefined }));
        }
    }, [isCloseAll]);

    const [isOpen, setIsOpen] = useState(false);

    const onClose = () => {
        dispatch(setterInspector({ isCloseAll: true }));
    };

    useEffect(() => {
        setTimeout(() => {
            setIsOpen(true);
        }, 500);
    }, []);

    return (
        <>
            {offsetRight > 0 ? (
                <div
                    style={{
                        padding: 10,
                        position: 'fixed',
                        right: offsetRight,
                        opacity: isOpen ? 1 : 0,
                        top: 0,
                        transform: isOpen ? `translateX(${0})` : `translateX(${50}px)`,
                        transition: 'transform .3s ease',
                        // boxShadow: '-2px 0 8px rgba(0, 0, 0, 0.2)',
                        zIndex: 2000 - offsetRight,
                    }}
                >
                    <div
                        style={{
                            backgroundColor: '#fff',
                            borderRadius: '50%',
                        }}
                    >
                        <Tooltip title={'Close All'} placement="top">
                            <Button
                                shape="circle"
                                onClick={onClose}
                                icon={<CloseCircleOutlined style={{ fontSize: 20 }} />}
                                type="text"
                                variant={'filled'}
                            />
                        </Tooltip>
                    </div>
                </div>
            ) : null}
        </>
    );
};
